<template>
  <header :class="$style.header">
    <h1 :class="[$style.header__title, $style.title]">
      <RouterLink :class="$style.title__link" :to="{ name: 'dashboard' }">
        <img
          src="@/assets/images/logo.svg?url"
          :class="[$style.header__logo, $style.logo]"
        />
      </RouterLink>
    </h1>
    <AppHeaderNavigation :class="$style.header__navigation" />
    <AppHeaderSettingLink :result="result?.viewer ?? null" />
  </header>
</template>

<script setup lang="ts">
import AppHeaderSettingLink from './AppHeaderSettingLink.vue'
import AppHeaderNavigation from './AppHeaderNavigation.vue'
import type { DefaultAppHeaderQueryFragment } from './AppHeader.generated'

defineProps<{ result: DefaultAppHeaderQueryFragment | null }>()
</script>

<style lang="scss" module>
.header {
  display: flex;
  height: 60px;
  box-sizing: border-box;
  align-items: center;
  padding: 0 40px;
  background-color: $color-surface-primary;
  box-shadow: $shadow-4;

  &__title {
    display: flex;
    align-items: center;
  }

  &__navigation {
    flex: 1;
    align-self: stretch;

    &:nth-child(n + 2) {
      margin-left: 40px;
    }
  }
}

.title {
  &__link {
    display: flex;
    align-items: center;
  }
}

.logo {
  width: 238px;
  height: auto;
}
</style>
